/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function groups(instance) {
	return {
		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageSize, pageNumber, config = {}) => {
			const pagingParams =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			return instance.get(`groups${pagingParams}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('groups', body, config)
		},

		/**
		 * @param {string } id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`groups/${id}`, config)
		},

		/**
		 * @param {string } id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (id, config = {}) => {
			return instance.get(`groups/${id}`, config)
		},

		/**
		 * @param {string } id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (id, body, config = {}) => {
			return instance.patch(`groups/${id}`, body, config)
		}
	}
}
